'use strict';

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isClient = typeof window !== 'undefined';
isClient && require('@ali/uc-intl-news-jssdk');

var _require = require('./try_to_share'),
    switchShareType = _require.switchShareType;

module.exports = function (config) {

  // 复制一份配置，以免污染了原先的配置
  var tempConfig = (0, _assign2.default)({}, config);

  var _tempConfig$shareBack = tempConfig.shareBackupList,
      shareBackupList = _tempConfig$shareBack === undefined ? [] : _tempConfig$shareBack;

  // 复制备用分享列表

  tempConfig.__tmpShareBackupList = (0, _assign2.default)([], typeof shareBackupList === 'string' ? [shareBackupList] : shareBackupList);
  // 把点击按钮对象存储起来，隐藏按钮时可以操作该dom对象
  event && (tempConfig.__target = event.target);

  switchShareType(tempConfig);
};